import React from 'react';
import { Caption1 } from '@fluentui/react-components';
import {
  TextField,
  PrimaryButton,
  DefaultButton,
  Stack,
  Label,
  IconButton,
  MessageBar,
  MessageBarType,
} from '@fluentui/react';
import { useNavigate } from 'react-router-dom';
import { PreviewCropModal } from '../../components/modals/PreviewCropModal';
import { InstructionsContainer, H1 } from '../Pages-styles';
import QuillEditor from '../../components/QuillEditor';
import { usePageContext } from '../../hooks/PageContext';
import { Attachment } from '../../graphql/types';

export const BlogEdit: React.FC = () => {
  const { actions } = usePageContext();
  const navigate = useNavigate();

  const {
    form, setForm, fileInputRef, handleImageUpload,
    imageState, handleCropComplete, setImageState,
    removeAttachment, attachmentInputRef, handleFileChange,
    handleCreate, handleEdit, isCreating, currentNote,
    notification, setNotification, setMode,
  } = actions;

  const getMessageBarType = (type: string): MessageBarType => {
    switch (type) {
      case 'success': return MessageBarType.success;
      case 'error': return MessageBarType.error;
      case 'info': return MessageBarType.info;
      case 'warning': return MessageBarType.warning;
      default: return MessageBarType.info;
    }
  };

  return (
    <>
      <InstructionsContainer>
        <IconButton
          iconProps={{ iconName: 'Back' }}
          title="Назад к списку"
          onClick={() => {
            setMode('list');
            navigate('/blog', { replace: true });
          }}
          style={{ marginBottom: '20px' }}
        />
        <H1>{isCreating ? 'Создать статью' : `Редактирование: ${currentNote?.title}`}</H1>

        <TextField
          label="Заголовок"
          value={form.title}
          onChange={(_, val) => setForm({ title: val || '' })}
          style={{ marginBottom: '8px', marginTop: '5px' }}
          required
        />

        <div style={{ marginBottom: '12px' }}>
          <Label>Изображение-превью (отображается в списке)</Label>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '8px' }}>
            {form.previewImage && (
              <img
                src={form.previewImage}
                alt="Превью"
                style={{ width: '100px', height: '33px', objectFit: 'cover', borderRadius: '4px' }}
              />
            )}
            <PrimaryButton
              text={form.previewImage ? 'Изменить' : 'Выбрать'}
              onClick={() => fileInputRef.current?.click()}
              style={{ height: '32px' }}
            />
            {form.previewImage && (
              <DefaultButton
                text="Удалить"
                onClick={() => setForm({ previewImage: '', image: '' })}
                style={{ height: '32px' }}
              />
            )}
          </div>
          <input
            type="file"
            accept="image/png, image/jpeg, image/gif, image/webp"
            hidden
            ref={fileInputRef}
            onChange={handleImageUpload}
          />
        </div>

        <TextField
          label="Теги (через запятую)"
          value={form.tags}
          onChange={(_, val) => setForm({ tags: val || '' })}
          style={{ marginBottom: '8px', marginTop: '5px' }}
        />

        <div style={{ marginBottom: '24px', marginTop: '5px' }}>
          <Label style={{ display: 'block', marginBottom: '8px' }}>
            Текст <span style={{ color: '#A80000' }}>*</span>
          </Label>
          <QuillEditor value={form.content} onChange={(content) => setForm({ content })} />
        </div>

        <div style={{ marginTop: '75px' }}>
          <Label style={{ display: 'block', marginBottom: '8px' }}>
            Вложения <span style={{ color: '#A80000', fontSize: '12px' }}>(для редактирования вложений, пожалуйста, очистите все старые)</span>
          </Label>
          <DefaultButton text="Добавить файлы" onClick={() => attachmentInputRef.current?.click()} />
          <input type="file" multiple accept="*/*" hidden ref={attachmentInputRef} onChange={handleFileChange} />
          {form.attachments.length > 0 && (
            <div style={{ marginTop: 8 }}>
              {form.attachments.map((file: Attachment, index: number) => (
                <div key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Caption1>{file.filename}</Caption1>
                  <IconButton iconProps={{ iconName: 'Delete' }} onClick={() => removeAttachment(index)} styles={{ root: { width: 24, height: 24 } }} />
                </div>
              ))}
            </div>
          )}
        </div>

        <p></p>
        {notification && (
          <MessageBar
            messageBarType={getMessageBarType(notification.type)}
            onDismiss={() => setNotification(null)}
            styles={{ root: { marginBottom: 20 } }}
          >
            {notification.message}
          </MessageBar>
        )}
        <p></p>

        <Stack horizontal tokens={{ childrenGap: 10 }} styles={{ root: { marginTop: 20 } }}>
          <PrimaryButton onClick={isCreating ? handleCreate : handleEdit}>
            {isCreating ? 'Создать' : 'Сохранить'}
          </PrimaryButton>
          <DefaultButton onClick={() => { setMode('list'); navigate('/blog', { replace: true }); }}>
            Отмена
          </DefaultButton>
        </Stack>
      </InstructionsContainer>

      {imageState.cropOpen && imageState.original && (
        <PreviewCropModal
          image={imageState.original}
          onCropComplete={handleCropComplete}
          onClose={() => setImageState({ cropOpen: false })}
          aspect={3 / 1}
        />
      )}
    </>
  );
};